// extracted by mini-css-extract-plugin
var _1 = "GroupChildCard-module__animateUploadProgressBarWidth--BHeSC";
var _2 = "GroupChildCard-module__animatedBackground--UVVke";
var _3 = "GroupChildCard-module__avatarsContainer--epjLW";
var _4 = "GroupChildCard-module__badgeContainer--kL9Pf";
var _5 = "GroupChildCard-module__card--QxyQc";
var _6 = "GroupChildCard-module__content--Lc5cx";
var _7 = "GroupChildCard-module__description--XjWmM";
var _8 = "GroupChildCard-module__menuContainer--CONjQ";
var _9 = "GroupChildCard-module__open--OSIQ9";
var _a = "GroupChildCard-module__overflowButton--mGd6O";
var _b = "GroupChildCard-module__title--O2v9Q";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarsContainer", _4 as "badgeContainer", _5 as "card", _6 as "content", _7 as "description", _8 as "menuContainer", _9 as "open", _a as "overflowButton", _b as "title" }
